@if (compact()) {
  <input #fileInput type="file" class="d-none" accept="image/*,.pdf" (change)="onFileSelected($event)" />
  @if (isBusy()) {
    <div class="placeholder-glow" [attr.title]="busyLabel()">
      <span class="placeholder placeholder-sm col-12 bg-gray-500 rounded d-block" style="height: 8px;"></span>
      <div class="small text-muted mt-1">{{ busyLabel() }}</div>
    </div>
  }
} @else if (!isEditing()) {
<div class="row align-items-center">
  <div class="col-lg-8 d-flex align-items-center">
    <div class="h-65px w-65px d-flex align-items-center justify-content-center position-relative">
      @if (isBusy()) {
        <div class="w-100 h-100 bg-gray-400 rounded placeholder placeholder-wave"></div>
      } @else if(document()?.filePath && document()?.mimeType?.includes('image')){
      <img [src]="baseUrl + document()?.filePath" class="mw-100 mh-100 shadow-sm border rounded"
        style="cursor: pointer;" (click)="onImageClick.emit(document().uuid || document().id)" title="Ver Galería">
      } @else if(document()?.filePath && document()?.mimeType?.includes('pdf')){
      <i class="fas fa-file-pdf fa-2x text-danger" style="cursor: pointer;" (click)="onImageClick.emit(document().uuid || document().id)" title="Ver PDF"></i>
      } @else {
      <i class="fas fa-file-circle-question fa-2x text-muted opacity-50"></i>
      }
    </div>
    <div class="ps-3 flex-1">
      <div>
        <a href="javascript:;" class="text-decoration-none text-dark">{{document()?.docTypeName}}</a>
      </div>
      @if (isBusy()) {
        <div class="placeholder-glow mt-1">
          <span class="placeholder placeholder-sm col-5 bg-gray-500"></span>
        </div>
      } @else if(document()?.expirationDate){
      <div class="text-dark text-opacity-50 small fw-bold"> Fecha Vencimiento: {{document()?.expirationDate | date:
        'dd/MM/yyyy'}} </div>
      }
    </div>
  </div>
  <div class="col-lg-2 m-0 ps-lg-3">
    @if (isBusy()) {
      <span class="placeholder placeholder-sm col-8 bg-gray-500 rounded-pill d-inline-block" style="height: 1.25rem;"></span>
    } @else {
      <span class="badge border" [ngClass]="document()?.statusStyle">{{document()?.statusName}} </span>
    }
  </div>
  <div class="col-lg-2 text-dark fw-bold m-0 text-end">
    @if (mode() === formMode.EDIT) {
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="editMode()" [disabled]="isBusy()">
        <i class="fas fa-edit"></i> Editar
      </button>
    }
  </div>
</div>

}

@else {
@if(documentForm()){

<form [formGroup]="documentForm()" class="document-upload">
  <div class="row mb-3 align-items-start">

    @if (isBusy()) {
      <div class="col-12">
        <label class="form-label mb-2">
          <strong>
            {{ document()?.docTypeName }}
            @if (document()?.isRequired) {
            <span class="text-danger">*</span>
            }
          </strong>
        </label>
        <div class="card overflow-hidden border-0 shadow-sm w-100" [attr.title]="busyLabel()">
          <div class="card-img-top bg-gray-400 placeholder placeholder-wave rounded-0" style="height: 90px;"></div>
          <div class="card-body py-2 px-3">
            <div class="placeholder-glow mb-1">
              <span class="placeholder placeholder-sm col-6 bg-gray-500"></span>
            </div>
            <div class="placeholder-glow">
              <span class="placeholder placeholder-xs col-4 bg-gray-500 me-2"></span>
              <span class="placeholder placeholder-xs col-3 bg-gray-500 me-2"></span>
              <span class="placeholder placeholder-xs col-2 bg-gray-500"></span>
            </div>
          </div>
        </div>
      </div>
    } @else {
    <div class="col-md-6" [ngClass]="{'col-md-8': !document()?.allowExpiration, 'col-12': compact()}">
      @if (!compact()) {
      <label class="form-label">
        <strong>
          {{ document()?.docTypeName }}
          @if (document()?.isRequired) {
          <span class="text-danger">*</span>
          }
        </strong>
      </label>
      }

      <input type="file" class="form-control form-control-sm" accept="image/*,.pdf"
        (change)="onFileSelected($event)" />
    </div>
    @if(document()?.allowExpiration){
    <div class="col-md-2">
      <label class="form-label">
        <strong>
          Fecha de Vencimiento
          @if (document()?.isRequired) {
          <span class="text-danger">*</span>
          }
        </strong>
      </label>

      <input type="date" class="form-control" formControlName="expirationDate"
        (change)="onExpirationDateChange($event)" />
    </div>
    }
    <div class="col-md-4">
      @if (previewUrl()) {
      <div class="mt-2 d-flex align-items-center">
        <img *ngIf="isImage" [src]="previewUrl()" class="img-thumbnail me-2"
          style="width:80px;height:80px;object-fit:cover" />

        <i *ngIf="!isImage" class="fas fa-file-pdf fa-2x text-danger"></i>

        <div class="ms-2 small text-muted">
          {{ documentForm().get('fileName')?.value }} <br>
          {{ documentForm().get('fileSize')?.value | number }} bytes
        </div>
      </div>
      }
    </div>

    @if (document()?.allowExpiration || document()?.filePath || (!document()?.isRequired && !document()?.filePath)) {
      <div class="col-md-12 mt-3">
        <div class="d-flex justify-content-end gap-2">
          @if (document()?.allowExpiration) {
            <button type="button" class="btn btn-primary btn-sm" (click)="saveDocument()">
              <i class="fas fa-save"></i> Guardar
            </button>
          }
          @if (document()?.filePath) {
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cancelEdit()">
              <i class="fas fa-times"></i> Cancelar
            </button>
          }
          @if (!document()?.isRequired) {
            <button type="button" class="btn btn-danger btn-sm" (click)="deleteDocument()">
              <i class="fas fa-trash"></i> Eliminar
            </button>
          }
        </div>
      </div>
    }
    }

  </div>
</form>
}
}
